/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    bedrooms: z.string().nullish(),
    bathrooms: z.string().nullish(),
    squareFootage: z.number().nullish(),
    neighborhood: z.string().nullish(),
    amenities: z.array(z.string()).nullish(),
}
).strict();
export const HousingDetailsSchema = baseSchema;
